var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgErrorText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 391,
    viewBox: "0 0 676 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.744 237.142L279.699 230.24L300.636 242.329L288.682 249.231L313.566 263.598L286.344 279.314L261.46 264.947L215.984 291.203L197.779 282.558L169.334 211.758L169.092 211.618L196.313 195.902L267.744 237.142ZM219.359 265.077L240.523 252.859L204.445 232.029L205.487 234.589L219.359 265.077Z",
    fill: "#FFAB91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.959 120.206L481.913 113.304L502.851 125.392L490.897 132.294L515.78 146.661L488.559 162.377L463.675 148.011L418.199 174.266L399.994 165.621L371.548 94.8211L371.307 94.6816L398.528 78.9654L469.959 120.206ZM421.574 148.141L442.737 135.922L406.66 115.093L407.701 117.653L421.574 148.141Z",
    fill: "#FFAB91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.523 235.027V232.237L219.401 265.014L240.555 252.926V255.018L218.936 267.339L204.523 235.027Z",
    fill: "#D84315"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.738 118.09V115.301L421.616 148.078L442.77 135.99V138.082L421.151 150.402L406.738 118.09Z",
    fill: "#D84315"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109.114,
    height: 136.405,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 220.507 181.925)",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40.2357,
    height: 70.0545,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 280.437 201.886)",
    fill: "url(#paint1_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1147,
    width: 80.1144,
    height: 107.405,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 223.872 194.482)",
    stroke: "#1565C0",
    strokeWidth: 29
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1147,
    width: 80.1144,
    height: 107.405,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 223.872 194.482)",
    stroke: "url(#paint2_linear)",
    strokeWidth: 29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.517 230.177L267.662 237.15L196.064 195.772L168.866 211.58L169.331 212.097L170.096 214.002L196.436 198.795L267.866 240.035L279.821 233.133L298.211 243.751L300.787 242.265L279.517 230.177ZM291.278 250.695L288.804 252.124L311.1 264.996L313.805 263.418L291.278 250.695Z",
    fill: "#D84315"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.732 113.24L469.877 120.214L398.279 78.8359L371.081 94.6433L371.546 95.1603L372.311 97.0652L398.651 81.8581L470.081 123.099L482.036 116.196L500.426 126.814L503.002 125.328L481.732 113.24ZM493.493 133.759L491.019 135.187L513.315 148.06L516.02 146.482L493.493 133.759Z",
    fill: "#D84315"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.674 252.229V249.207L291.929 251.067L288.674 252.229Z",
    fill: "#D84315"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.7511,
    y1: 139.902,
    x2: -10.8629,
    y2: 8.75671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3076C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992076,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25.8162,
    y1: 51.0447,
    x2: 68.7073,
    y2: -5.41524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E75C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4283CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -16.1224,
    y1: -47.972,
    x2: 123.494,
    y2: 290.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgErrorText);
export default __webpack_public_path__ + "static/media/img-error-text.331a1f9141d6e334ca87c95f581469b5.svg";
export { ForwardRef as ReactComponent };